import {presentPhoneScriptCreation} from "./presentations/phoneScript";
import {DEFAULT_SKILLS, humanizeName} from "./skills";
import {isPresentationRecord, presentedFields, type ToolPresentation} from "./toolPresentation";

type Translate = (key: string, options?: Record<string, unknown>) => string;
type ToolPresenter = (presentation: ToolPresentation, input: unknown, t: Translate) => ToolPresentation;

const toolPresenters: ReadonlyMap<string, ToolPresenter> = new Map([
   ["phone_scripts_create", presentPhoneScriptCreation],
]);

/** Stable operation identities select UI copy, independently of the server's fallback text. */
const campaignCopy: Readonly<Record<string, string>> = {
   campaigns_start: "toolApproval.campaign.start",
   campaigns_stop: "toolApproval.campaign.stop",
   campaigns_archive: "toolApproval.campaign.archive",
};

export function knownToolActivity(toolName: string, input: unknown, t: Translate) {
   if (toolName === "load_skill" || toolName === "load_gail_skill") {
      const skillName = isPresentationRecord(input) && typeof input.skillName === "string" ? input.skillName.trim() : "";
      const preset = Object.hasOwn(DEFAULT_SKILLS, skillName) ? DEFAULT_SKILLS[skillName] : undefined;
      const name = preset ? t(`skills.${preset.key}.title`) : humanizeName(skillName);
      return {icon: "wrench" as const,
         inProgressText: name ? t("tools.phrases.loadingSkillNamed", {name}) : t("tools.phrases.activatingSkill"),
         completedText: name ? t("tools.phrases.loadedSkillNamed", {name}) : t("tools.phrases.activatedSkill")};
   }
   const key = Object.hasOwn(campaignCopy, toolName) ? campaignCopy[toolName] : undefined;
   if (key) return {icon: "wrench" as const, inProgressText: t(`${key}.title`), completedText: t(`${key}.title`)};
}

/** Render-only projection. Never write translated copy into the frozen approval or request. */
export function displayToolPresentation(presentation: ToolPresentation, input: unknown, t: Translate): ToolPresentation {
   const present = toolPresenters.get(presentation.toolName);
   if (present) return present(presentation, input, t);
   const key = Object.hasOwn(campaignCopy, presentation.toolName) ? campaignCopy[presentation.toolName] : undefined;
   if (!key) return presentation;
   return {...presentation,
      title: {text: t(`${key}.title`)},
      description: {text: t(`${key}.description`)},
      approveLabel: {text: t(`${key}.approve`)},
      fields: presentedFields(input, presentation.fields).map(({value: _value, ...field}) =>
         field.path.length === 1 && field.path[0] === "id"
            ? {...field, label: {text: t("toolApproval.entities.campaign")}, format: "entity", emphasis: "primary"}
            : field),
   };
}
